import Popup from '../components/common/Popup';

export default {
    components: { Popup },
    methods: {
        promptAlert(message, onClose, type, title) {
            if (!title) {
                var title = type === 'success' ? this.$t('general.success') : this.$t('general.oops');
            }
            var PopupClass = Vue.extend(Popup)
            var instance = new PopupClass({
                propsData: {
                    mode: 'alert',
                    title: title,
                    message: message
                }
            });
            // Set up event handling
            let closing = () => {
                if (onClose) {
                    onClose.apply(this);
                }
                instance.$destroy();
                if (instance.$el && instance.$el.parentElement) {
                    instance.$el.parentElement.removeChild(instance.$el);
                }
            };
            instance.$on('close', closing);
            instance.$on('cancel', closing);

            // Mount
            instance.$mount()
            $('body').append(instance.$el);
        },
        promptLoading(message) {
            var PopupClass = Vue.extend(Popup)
            var instance = new PopupClass({
                propsData: {
                    mode: 'loading',
                    message: message
                }
            });
            // Mount
            instance.$mount()
            $('body').append(instance.$el);

            return () => {
                instance.$destroy();
                if (instance.$el && instance.$el.parentElement) {
                    instance.$el.parentElement.removeChild(instance.$el);
                }
            };
        },
        promptInput(title, message, inputPlaceholder, confirmButtonText, onConfirm, confirmButtonClass, cancelButtonText, onCancel) {
            var PopupClass = Vue.extend(Popup)
            var instance = new PopupClass({
                propsData: {
                    mode: 'prompt',
                    title: title || this.$t('general.confirm'),
                    message: message,
                    placeholder: inputPlaceholder,
                    confirmText: confirmButtonText,
                    confirmButtonClass: confirmButtonClass,
                    cancelText: cancelButtonText || this.$t('general.cancel'),
                }
            });
            // Set up event handling
            let closing = () => {
                instance.$destroy();
                if (instance.$el && instance.$el.parentElement) {
                    instance.$el.parentElement.removeChild(instance.$el);
                }
            };
            instance.$on('close', closing);
            instance.$on('cancel', () => {
                if (onCancel) {
                    onCancel.apply(this);
                }
                closing.apply(this);
            });
            instance.$on('confirm', () => {
                onConfirm.apply(this, [instance.getUserInput()]);
                closing.apply(this);
            });

            // Mount
            instance.$mount()
            $('body').append(instance.$el);

        },
        promptConfirm(message, confirmButtonText, onConfirm, confirmButtonClass, cancelButtonText, onCancel) {
            var PopupClass = Vue.extend(Popup)
            var instance = new PopupClass({
                propsData: {
                    mode: 'confirm',
                    title: this.$t('general.confirm'),
                    message: message,
                    confirmText: confirmButtonText,
                    confirmButtonClass: confirmButtonClass,
                    cancelText: cancelButtonText || this.$t('general.cancel'),
                }
            });
            // Set up event handling
            let closing = () => {
                instance.$destroy();

                if (instance.$el && instance.$el.parentElement) {
                    instance.$el.parentElement.removeChild(instance.$el);
                }
            };
            instance.$on('close', closing);
            instance.$on('cancel', () => {
                if (onCancel) {
                    onCancel.apply(this);
                }
                closing.apply(this);
            });
            instance.$on('confirm', () => {
                onConfirm.apply(this);
                closing.apply(this);
            });

            // Mount
            instance.$mount()
            $('body').append(instance.$el);
        }
    }
}
